import { __decorate } from "tslib";
import { AutoEncoder, field, StringDecoder } from '@simonbackx/simple-encoding';
import { Country } from '@stamhoofd/types/Country';
import { Formatter } from '@stamhoofd/utility';
import { v4 as uuidv4 } from 'uuid';
import { Address } from './addresses/Address.js';
export class PeppolEndointId extends AutoEncoder {
    schemeID;
    id;
}
__decorate([
    field({ decoder: StringDecoder })
], PeppolEndointId.prototype, "schemeID", void 0);
__decorate([
    field({ decoder: StringDecoder })
], PeppolEndointId.prototype, "id", void 0);
export class Company extends AutoEncoder {
    id;
    /**
     * Legal name of the organization (optional)
     */
    name = '';
    VATNumber = null;
    companyNumber = null;
    address = null;
    administrationEmail = null;
    customPeppolEndpointId;
    get peppolEndpointId() {
        if (this.customPeppolEndpointId) {
            return this.customPeppolEndpointId;
        }
        return this.peppolCompanyId;
    }
    get peppolCompanyId() {
        if (this.address?.country !== Country.Belgium) {
            // Unsupported
            return null;
        }
        const companyNumberOrVAT = this.VATNumber ?? this.companyNumber;
        if (!companyNumberOrVAT) {
            return null;
        }
        const companyNumber = (this.VATNumber ? this.VATNumber.substring(2) : companyNumberOrVAT).replace(/\D+/g, '');
        const id = Formatter.slugVATNumber(companyNumber);
        return PeppolEndointId.create({
            schemeID: '0208', // Belgium
            id,
        });
    }
    getDiffValue() {
        return this.name;
    }
    equals(other) {
        if (this.name !== other.name) {
            return false;
        }
        if (this.VATNumber !== other.VATNumber) {
            return false;
        }
        if (this.companyNumber !== other.companyNumber) {
            return false;
        }
        if (this.address && other.address) {
            if (!this.address.equals(other.address)) {
                return false;
            }
        }
        else if (!!this.address !== !!other.address) {
            return false;
        }
        if (this.administrationEmail !== other.administrationEmail) {
            return false;
        }
        return true;
    }
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], Company.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder })
], Company.prototype, "name", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], Company.prototype, "VATNumber", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], Company.prototype, "companyNumber", void 0);
__decorate([
    field({ decoder: Address, nullable: true })
], Company.prototype, "address", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true, optional: true })
], Company.prototype, "administrationEmail", void 0);
__decorate([
    field({ decoder: PeppolEndointId, nullable: true, version: 399 })
], Company.prototype, "customPeppolEndpointId", void 0);
//# sourceMappingURL=Company.js.map